/* 
  The selection overflow is a component that is used to display the options that have been selected from the dropdown.
  This component appears in the table under the Empfänger Übersicht section. Each row has its own selection overflow.
  The dropdown has E-Post, Portal and MANUELL as options. We are adding the E-Mail option.
*/

let rowKey = undefined
let isButtonListenerSetup = false // Add flag to prevent multiple listener registrations
const documentSourceIdRegex =
  /^source-DUNNING(_ANNEX|_DD_MANDATE)?-(\d+)-prp-\d+$/
const propertyUrlRegex =
  /\/properties\/\w+\/edit\/unit\/(\d+)\/contract\/all\/edit\/(\d+)/
const contactUrlRegex = /\/contacts\/(\d+)/

const checkboxClassName = '.impowerx-email-checkbox .ant-checkbox'
const emailSelectionElementClassName = '.ant-select-selection-overflow-item.impowerx-email-selection-element'

const emailDropdownElementMarkup = `
  <div class="ant-select-selection-overflow-item impowerx-email-selection-element" style="opacity: 1;">
    <span class="ant-select-selection-item" title="E-Mail">
      <span class="ant-select-selection-item-content">E-Mail</span>
      <span class="ant-select-selection-item-remove" unselectable="on" aria-hidden="true" style="user-select: none;" onclick="handleRemoveEmailOption(this)">
        <span role="img" class="anticon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259972 4.80025 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34672 12 7.18669 12 6C12 5.21207 11.8448 4.43185 11.5433 3.7039C11.2417 2.97594 10.7998 2.31451 10.2426 1.75736C9.68549 1.20021 9.02406 0.758251 8.2961 0.456723C7.56815 0.155195 6.78793 0 6 0ZM9 8L8 9L6 7L4 9L3 8L5 6L3 4L4 3L6 5L8 3L9 4L7 6L9 8Z" fill="black"></path>
          </svg>
        </span>
      </span>
    </span>
  </div>
`

// handle the click in the selection overflow x button
handleRemoveEmailOption = (element) => {
  // remove the E-Mail option from the selection overflow
  $(element)
    .closest(emailSelectionElementClassName)
    .remove()

  // remove the tick from the E-Mail option in the dropdown
  $(`.ant-select-item-option-state[data-row-key="${rowKey}"]`).remove()

  // change the icon for the checkbox accordingly
  $(checkboxClassName).removeClass('ant-checkbox-checked')

  if ($(emailSelectionElementClassName).length > 0) { // if at least one E-Mail option is selected
    $(checkboxClassName).addClass('ant-checkbox-indeterminate')
  } else {
    $(checkboxClassName).removeClass('ant-checkbox-indeterminate')
  }

  handleSelectionOverflowPlaceholder(rowKey)
}

handleSelectionOverflowPlaceholder = (key) => {
  const optionsCount = $(
    `tr[data-row-key="${key}"] .ant-select-selection-overflow .ant-select-selection-overflow-item`
  ).length
  const placeholder = $(
    `tr[data-row-key="${key}"] .ant-select-selection-placeholder`
  )

  // NOTICE: there is always an empty element in the selection overflow
  if (optionsCount === 2) {
    // hide the "Bitte auswählen..." placeholder
    placeholder.hide()
  } else if (optionsCount === 1) {
    // show the "Bitte auswählen..." placeholder
    placeholder.show()
  }
}

// handle the click in the options dropdown
handleDropdownClick = (element) => {
  // if the E-Mail option in the dropdown is clicked, add a tick to the option and add the E-Mail option to the selection overflow
  if (!$(element).find('.ant-select-item-option-state').length) {
    // add the tick icon to the E-Mail option
    $(element).append(emailDropdownElementTick(rowKey))

    if (!$(`tr[data-row-key="${rowKey}"] .ant-select-selection-overflow`).find('.impowerx-email-selection-element').length) {
      // add the E-Mail option to the selection overflow
      $(`tr[data-row-key="${rowKey}"] .ant-select-selection-overflow`).append(emailDropdownElementMarkup)
    }
  } else {
    // remove the tick icon from the E-Mail option
    $(element).find('.ant-select-item-option-state').remove()

    // remove the E-Mail option from the selection overflow
    $(`tr[data-row-key="${rowKey}"] .impowerx-email-selection-element`).remove()
  }

  // if there is no items in the selection overflow, show the "Bitte auswählen..." placeholder
  handleSelectionOverflowPlaceholder(rowKey)

  const selectedEmailCount = $(emailSelectionElementClassName).length

  // change the icon for the checkbox accordingly
  if (selectedEmailCount === 0) {
    $(checkboxClassName).removeClass('ant-checkbox-indeterminate ant-checkbox-checked')
  } else if (selectedEmailCount > 0 && selectedEmailCount < $('.ant-select-selection-overflow').length) {
    $(checkboxClassName).addClass('ant-checkbox-indeterminate')
  } else if (selectedEmailCount === $('.ant-select-selection-overflow').length) {
    $(checkboxClassName).removeClass('ant-checkbox-indeterminate').addClass('ant-checkbox-checked')
  }

  // close the dropdown
  $('.ant-select-dropdown').addClass('ant-select-dropdown-hidden')
}

onCheckboxClicked = (isChecked) => {
  if (isChecked) {
    $(`tr .ant-select-selection-overflow`).each((index, elem) => {
      if ($(elem).find('.impowerx-email-selection-element').length === 0) {
        $(elem).append(emailDropdownElementMarkup)
      }
    })

    // if the Manuell checkbox is not checked, check it
    const manualCheckbox = Array.from(document.querySelectorAll('span')).find(span => span.textContent === 'Manuell')?.closest('.ant-checkbox-wrapper')
    if (!$(manualCheckbox).find('.ant-checkbox').hasClass('ant-checkbox-checked')) {
      $(manualCheckbox).trigger('click')
    }
  } else {
    $(`tr .ant-select-selection-overflow .impowerx-email-selection-element`).remove()

    // remove the tick icon from the E-Mail option
    $('.impowerx-email-dropdown-element-tick').remove()
  }

  $('.BasicTable tr.ant-table-row').each((index, elem) => {
    if ($(elem).hasClass('ant-table-row-level-1')) {
      const key = $(elem).attr('data-row-key')

      if (key) {
        handleSelectionOverflowPlaceholder(key)
      }
    }
  })
}

const emailCheckboxMarkup = `
  <div class="CheckboxInput impowerx-email-checkbox">
    <div class="ant-row ant-form-item ant-form-item-with-help" style="row-gap: 0px;">
      <div class="ant-col ant-form-item-control">
        <div class="ant-form-item-control-input">
          <div class="ant-form-item-control-input-content">
            <label class="ant-checkbox-wrapper ant-checkbox-wrapper-disabled ant-checkbox-wrapper-in-form-item">
              <span class="ant-checkbox ant-checkbox-disabled">
                <input type="checkbox" disabled="" class="ant-checkbox-input" value="" onclick="handleCheckboxClick(this, onCheckboxClicked)" />
                <span class="ant-checkbox-inner"></span>
              </span>
              <span>E-Mail</span>
            </label>
          </div>
        </div>
        <div class="ant-form-item-explain ant-form-item-explain-connected">
          <div role="alert" class=""></div>
        </div>
      </div>
    </div>
  </div>
`

const emailDropdownElementTick = (rowKey) => `
  <span class="ant-select-item-option-state impowerx-email-dropdown-element-tick" data-row-key="${rowKey}" unselectable="on" aria-hidden="true" style="user-select: none;">
    <span role="img" aria-label="check" class="anticon anticon-check">
      <svg viewBox="64 64 896 896" focusable="false" data-icon="check" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path>
      </svg>
    </span>
  </span>
`

const emailDropdownElement = `
  <div aria-selected="true" onclick="handleDropdownClick(this)" class="ant-select-item ant-select-item-option ant-select-item-option-active ant-select-item-option-selected impowerx-email-dropdown-element" title="E-Mail">
    <div class="ant-select-item-option-content">
      <div class="select-menu-item">E-Mail</div>
    </div>
  </div>
`

const onOpenBalancesPageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector('#MessageDocumentTable')

    if (pageContent) {
      clearInterval(waitForPageLoad)
      onOpenBalancesPageLoaded()
    }
  }, 100)
}

const onOpenBalancesPageLoaded = () => {
  const radioGroupSelector =
    '.DistributionModeRow .RadioGroupInput .ant-radio-group .radio-group-option[data-testid="radio-group-option-false"] .ant-radio-wrapper-checked .ant-radio-input'

  if ($('.impowerx-email-checkbox').length === 0) {
    // add the E-Mail checkbox to the distribution options
    $('.distribution-option-checkboxes').append(emailCheckboxMarkup)
  }

  // Observe the Zustellung radio options
  initateAnObserver(() => {
    const checkedRadio = $(radioGroupSelector).val()

    if (checkedRadio === 'false') {
      // enable the E-Mail checkbox
      $('.impowerx-email-checkbox .ant-checkbox-wrapper').removeClass(
        'ant-checkbox-wrapper-disabled'
      )
      $(checkboxClassName).removeClass(
        'ant-checkbox-disabled'
      )
      $('.impowerx-email-checkbox .ant-checkbox-input').removeAttr('disabled')

      // add the E-Mail dropdown element to the receipient dropdown
      const elements = document.querySelectorAll(
        '.rc-virtual-list-holder-inner .select-menu-item'
      )
      Array.from(elements)
        .filter((element) => element.textContent.trim() === 'Manuell')
        .forEach((element) => {
          if (
            !$(element)
              .closest('.rc-virtual-list-holder-inner')
              .find('.impowerx-email-dropdown-element').length
          ) {
            $(element)
              .closest('.rc-virtual-list-holder-inner')
              .append(emailDropdownElement)
          }
        })
    } else {
      // disable the E-Mail checkbox
      $('.impowerx-email-checkbox .ant-checkbox-wrapper').addClass(
        'ant-checkbox-wrapper-disabled'
      )
      $(checkboxClassName).addClass(
        'ant-checkbox-disabled'
      )
      $('.impowerx-email-checkbox .ant-checkbox-input').attr('disabled', true)
    }
  }, radioGroupSelector)

  $(document).on('click', function (event) {
    if ($(event.target).closest('.ant-select-in-form-item').length) {
      rowKey = $(event.target).closest('tr').attr('data-row-key')
    }
  })

  function getDocumentsBySourceId() {
    const ids = []

    $('.ant-table-row.ant-table-row-level-1[data-row-key^="source-"]').each(
      (index, elem) => {
        const rowKey = $(elem).attr('data-row-key')
        const matched = rowKey.match(documentSourceIdRegex)
        if (matched) ids.push(matched[2])
      }
    )

    if (ids.length > 0 && ids.every((element) => element && element === ids[0]))
      return ids[0]
    return null
  }

  function getDocumentsByDocumentsIds() {
    const ids = []

    $('.ant-table-row.ant-table-row-level-1[data-row-key^="doc-"]').each((index, elem) => {
      const rowKey = $(elem).attr('data-row-key')
      if (rowKey) ids.push(rowKey.replace('doc-', ''))
    })

    return ids
  }

  function getEmailOptions() {
    const emailOption = []
    let tempEmailOption = {}

    $('.BasicTable tr.ant-table-row').each((index, elem) => {
      if ($(elem).hasClass('ant-table-row-level-0')) {
        // header row
        const propertyLink = $(elem).find('a[href^="/properties/"]')

        if (propertyLink.length) {
          const match = $(propertyLink[0])
            ?.attr('href')
            ?.match(propertyUrlRegex)

          if (match) {
            tempEmailOption.unitId = match[1]
            tempEmailOption.contractId = match[2]
          }
        }
      } else if ($(elem).hasClass('ant-table-row-level-1')) {
        // data row
        const contactLink = $(elem).find('a[href^="/contacts/"]')
        const hasEmailOption =
          $(elem).find('.impowerx-email-selection-element').length > 0

        if (contactLink.length) {
          const match = $(contactLink[0])?.attr('href')?.match(contactUrlRegex)

          if (match) {
            tempEmailOption.contactId = match[1]
          }
        }

        if (hasEmailOption) {
          emailOption.push(tempEmailOption)
        } 

        tempEmailOption = {}
      }
    })

    return emailOption
  }

  if (!isButtonListenerSetup) {
    listenToButtonClick('Ausführen', async () => {
      const isEmailCheckboxChecked = $('.impowerx-email-checkbox .ant-checkbox-checked').length > 0
      const isManuellCheckboxChecked = $('.distribution-option-checkboxes .CheckboxInput:nth-child(3) .ant-checkbox-checked').length > 0

      if (isEmailCheckboxChecked && !isManuellCheckboxChecked) {
        alert('Um Mahnungen per E-Mail versenden zu können, muss sowohl Manuell, als auch E-Mail als Option ausgewählt sein')
      }
    })

    listenToButtonClick('Versenden', async () => {
      const isEmailCheckboxChecked = $('.impowerx-email-checkbox .ant-checkbox-checked').length > 0
      const isAnyEmailOptionSelected = $('.impowerx-email-selection-element').length > 0

      if (isEmailCheckboxChecked || isAnyEmailOptionSelected) {
        const sourceId = getDocumentsBySourceId()
        const documentsIds = getDocumentsByDocumentsIds()
        const emailOptions = getEmailOptions()
        console.log(sourceId, documentsIds, emailOptions)

        if ((sourceId || documentsIds.length > 0) && emailOptions.length > 0) {
          await saveImpowerXData(`${baseApiUrl}/api/impowerX/dunning-emails`, {
            emailOptions,
            sourceId,
            documentsIds,
          })
        } else { 
          // TODO: add a toast instead of the alert
          alert('No source ID or email options found')
        }
      }
    })
    isButtonListenerSetup = true
  }
}
